module.exports = __webpack_public_path__ + "img/map_arrow.239e06f1.png";